/* global Site */

/**
 * composables -kansiossa olevat tiedostot on tarkoituksella pilkottu päätiedostoista (search.js, services.js etc.)
 * Tämä johtuu siitä, että näissä tiedostoissa olevia datoja tai funktioita käytetään tismalleen samanlaisena eri
 * komponenteissa, jos niihin jostain syystä tarvitsee tehdä muutoksia, ei niitä tarvitse muistaa tehdä useaan paikkaan
 *
 * Vuen mukaan composablejen prefixinä tulisi käyttää use-sanaa (useFunktionNimi)
 *
 * Modaliin liittyvät funktiot
 */

export const useModalData = {
	show: false,
	title: '',
	description: '',
	href: '',
	startDate: '',
	endDate: '',
	type: 'tapahtuma',
};

/**
 * Avaa modaalin ja näyttää tapahtumaan liittyvän datan
 * @param {object} data Modaalin data
 */
export function useOpenModal(data) {
	this.useModalData.show = true;

	this.useModalData.title = this.useGetTitle(data);
	this.useModalData.description = this.useGetDesc(data);
	this.useModalData.owner = data.owner;
	this.useModalData.href = data.permalink;

	// Estetään bodyn scrollaaminen kun modaali on auki
	document.body.classList.add('noscroll');
}
/**
 * Sulkee modaalin
 */
export function useCloseModal() {
	this.useModalData.show = false;

	// Sallitaan bodyn scrollaaminen kun modaali suljetaan
	document.body.classList.remove('noscroll');
}
